import { isArray } from 'util';
import { sortByString, mapCollection } from '../../utils/collection.utils';
import { Product } from '../product';
import { ComplementBuilder } from './complement-builder';
import { parseNumber } from '../../utils/number.utils';
import { ProductTypeBuilder } from './product-type.builder';
import { BrandBuilder } from './brand.builder';

export class ProductBuilder {

  static fromJson(json): Product {
    return (json) ? new Product(
      json.hash,
      json.name,
      json.code,
      parseNumber(json.price),
      parseNumber(json.weight),
      json.description,
      json.needSerialNumber,
      json.productType ? ProductTypeBuilder.fromJson(json.productType) : null,
      json.brand ? BrandBuilder.fromJson(json.brand) : null,
      (isArray(json.complements)) ? mapCollection(ComplementBuilder.fromJson, json.complements) : []
    ) : null;
  }

  static fromJsonList(list): Product[] {
    return (isArray(list)) ? sortByString('name', mapCollection(ProductBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/product-builder.ts